export const MachuFotos = [
{
id:'1',
img:require('../Image/Rioplyas.jpg'),
Title:'Ciudadela de Machu Pichu'

},

{
    id:'2',
    img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
    Title:'Ciudadela de Machu Pichu'
    
},

{
    id:'3',
    img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
    Title:'Ciudadela de Machu Pichu'
   
    
},
{
    id:'4',
    img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
    Title:'Ciudadela de Machu Pichu'
   
    
},
{
    id:'5',
    img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
    Title:'Ciudadela de Machu Pichu'
   
    
},
{
    id:'6',
    img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
    Title:'Ciudadela de Machu Pichu'
   
    
},
{
    id:'7',
    img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
    Title:'Ciudadela de Machu Pichu'
   
    
},
{
    id:'8',
    img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
    Title:'Ciudadela de Machu Pichu'
   
    
},
{
    id:'9',
    img:'https://m.media-amazon.com/images/I/81aDxpFVw8L._AC_UF1000,1000_QL80_.jpg',
    Title:'Ciudadela de Machu Pichu'
   
    
},




]